// ─────────────────────────────────────────────────────────────────
// Glass-i — Employee History helpers (Stage HRMS-3). Pure functions.
// Event vocabulary is lockstep with hr_employee_history CHECK (migr 0128)
// and the backend EVENT_TYPES.
// ─────────────────────────────────────────────────────────────────

export const EVENT_TYPES = [
  'EMPLOYEE_CREATED', 'EMPLOYEE_UPDATED',
  'BRANCH_CHANGED', 'DEPARTMENT_CHANGED', 'DESIGNATION_CHANGED', 'MANAGER_CHANGED',
  'STATUS_CHANGED',
  'LOGIN_ENABLED', 'LOGIN_DISABLED', 'LOGIN_LOCKED', 'LOGIN_UNLOCKED',
  'SALESPERSON_ENABLED', 'SALESPERSON_DISABLED', 'SALESPERSON_SETTINGS_UPDATED',
  'CUSTOMER_ASSIGNMENT_CHANGED',
  'DOCUMENT_ADDED', 'CONTACT_ADDED', 'ADDRESS_ADDED',
  'TRANSFER_APPROVED'
];

export function eventLabel(evt) {
  return String(evt || '')
    .toLowerCase()
    .split('_')
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : w))
    .join(' ');
}

export const EVENT_TYPE_OPTIONS = EVENT_TYPES.map((v) => ({ value: v, label: eventLabel(v) }));

export function eventTagColor(evt) {
  const e = String(evt || '').toUpperCase();
  if (e === 'EMPLOYEE_CREATED') return 'green';
  if (e === 'TRANSFER_APPROVED') return 'geekblue';
  if (e.endsWith('_LOCKED') || e === 'LOGIN_DISABLED' || e === 'SALESPERSON_DISABLED') return 'volcano';
  if (e.endsWith('_ENABLED') || e === 'LOGIN_UNLOCKED') return 'cyan';
  if (e.endsWith('_CHANGED')) return 'gold';
  if (e.endsWith('_ADDED')) return 'blue';
  return 'default';
}

// Render a small JSON snapshot as "k=v, k=v". Null / empty → em dash.
export function formatSnapshot(obj) {
  if (obj === null || obj === undefined) return '—';
  if (typeof obj !== 'object') return String(obj);
  const entries = Object.entries(obj);
  if (!entries.length) return '—';
  return entries.map(([k, v]) => `${k}=${v === null || v === undefined ? '∅' : v}`).join(', ');
}
